<template>

    <!-- A fake dashboard top card, to see the images in situation. -->

    <trax-ui-card-with-background class="trax-top-box trax-background-preview-box"
        vertical-align="center" :background-image="image">

        <h6 class="card-category">{{ lang.polaris.settings.background_preview }}</h6>
        <h2 class="card-title">{{ title }}</h2>
        <p class="card-description">{{ lang.polaris.settings.background_preview_notice }}</p>

    </trax-ui-card-with-background>

</template>

<script>
    export default {

        props: ['bus', 'id'],

        data: function() {
            return {
                lang: lang,
                image: 'default.jpg',
                name: null
            }
        },

        computed: {

            title() {
                return this.name ? this.name : this.lang.polaris.settings.background_preview_hint;
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(this.id+'-preview', function(background) {
                that.image = background.url;
                that.name = background.name;
            });
        }

    }
</script>
